
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lookup",
      function () {
        return require("private-next-pages/lookup.js");
      }
    ]);
  